import React from "react";
import {
    Box,
    Card,
    CardContent,
} from '@mui/material';
import DataListRowItem from './dataListRowItem';

const DataCard = (props) => {
    const { classes, item, index } = props;
    return (
        <Card
            onClick={() => item.actualData.appNotificationID ? props.handleAppNotificationClick(item.actualData) : null}
            classes={{ root: classes.paperContent }}
            sx={{ width: '100%'}}
            style={{backgroundColor: item.actualData.preference && item.actualData.preference > 0 ? "#ccc" : "" }}
        >
            <CardContent sx={{ p: 2 }} className={classes.cardContent}>
                <Box className={classes.rowContent}>
                    <>
                        {item.row.map((row, rowIndex) => (
                            <DataListRowItem
                                key={`datarowitem_${rowIndex}`}
                                row={row}
                                item={item}
                                index={index}
                                {...props}
                            />
                        ))}
                    </>
                </Box>
            </CardContent>
        </Card>
    )
}

export default DataCard;